import { render, staticRenderFns } from "./SimpleSutronImporter.vue?vue&type=template&id=46c7662c&scoped=true"
import script from "./SimpleSutronImporter.vue?vue&type=script&lang=js"
export * from "./SimpleSutronImporter.vue?vue&type=script&lang=js"
import style0 from "./SimpleSutronImporter.vue?vue&type=style&index=0&id=46c7662c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7662c",
  null
  
)

export default component.exports